import FeatureGates from '@atlaskit/feature-gate-js-client';

import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils';
import { useIsCompanyHubEnabled } from '@confluence/company-hub-utils/entry-points/useIsCompanyHubEnabled';

export const useIsInCompanyHubUnpublishedState = (spaceKey: string) => {
	const isCompanyHub = isCompanyHubSpaceKey(spaceKey);
	const { isCompanyHubPublished } = useIsCompanyHubEnabled();
	const isCompanyHubGAEnabled = FeatureGates.checkGate(
		'confluence_frontend_company_hub_ga_updates',
	);

	return isCompanyHub && isCompanyHubGAEnabled && !isCompanyHubPublished;
};
